import React from 'react';
import './Contact.css';

export default function Contact() {
    return (
        <div id="contact" className="contact-container">
            <h1 className="contact-title">زورونا</h1>
            <p className="contact-subtitle">يمكنك العثور علينا في المواقع الموضحة أدناه</p>
            
            <div className="map-section">
                <div className="map-container">
                    <h2 className="map-title">مركز جدة</h2>
                    <iframe
                        title="موقع مركز بالي طلاسو - جدة"
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3711.1713671283986!2d39.20048451493225!3d21.57164508573167!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x15c3d1e01ca55e29%3A0xb9e91d8745d3cc5e!2zSM6QMitKNUcsIFByaW5jZSBNYWppZCBSZCwgQWwtU2FmYSwgSmVkZGFoIDIzNDUxLCDYp9mE2K_ZitmB!5e0!3m2!1sen!2ssa!4v1625678746141!5m2!1sen!2ssa"
                        className="map-frame"
                        allowFullScreen=""
                        aria-hidden="false"
                        tabIndex="0"
                    ></iframe>
                </div>
            </div>
        </div>
    );
}
